import { render, staticRenderFns } from "./WorkProcedure.vue?vue&type=template&id=30c917a0&scoped=true&"
import script from "./WorkProcedure.vue?vue&type=script&lang=js&"
export * from "./WorkProcedure.vue?vue&type=script&lang=js&"
import style0 from "./WorkProcedure.vue?vue&type=style&index=0&id=30c917a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c917a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c917a0')) {
      api.createRecord('30c917a0', component.options)
    } else {
      api.reload('30c917a0', component.options)
    }
    module.hot.accept("./WorkProcedure.vue?vue&type=template&id=30c917a0&scoped=true&", function () {
      api.rerender('30c917a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/WorkProcedure.vue"
export default component.exports